import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsThisFor() {
  const isFor = ['Women 60+ who are tired of waking up feeling "puffy" and stiff.', 'Those who want to maintain their independence and mobility for years to come.', 'Women who love good food but hate spending hours standing in the kitchen.', 'Anyone who feels like their "get up and go" has been replaced by chronic fatigue.'];
  const notFor = ['People looking for a "rapid weight loss" crash diet.', 'Those who enjoy spending hours preparing complex, gourmet meals.', 'Anyone looking for professional medical or surgical advice.'];
  return <section className="bg-cream-dark py-6 px-4 md:px-8" data-id="element-191">
      <div className="max-w-3xl mx-auto" data-id="element-192">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-193">
          <FadeIn data-id="element-194">
            <div className="bg-white rounded-xl p-4 shadow-md h-full border-t-4 border-forest" data-id="element-195">
              <h3 className="text-lg md:text-xl font-bold text-forest mb-3" data-id="element-196">
                This Is For You If...
              </h3>
              <ul className="space-y-2.5" data-id="element-197">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-2.5" data-id="element-198">
                    <div className="bg-green-100 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-199">
                      <Check className="w-4 h-4 text-forest" strokeWidth={3} data-id="element-200" />
                    </div>
                    <span className="text-sm text-charcoal" data-id="element-201">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-202">
            <div className="bg-white rounded-xl p-4 shadow-md h-full border-t-4 border-red-500" data-id="element-203">
              <h3 className="text-lg md:text-xl font-bold text-red-600 mb-3" data-id="element-204">
                This Is NOT For You If...
              </h3>
              <ul className="space-y-2.5" data-id="element-205">
                {notFor.map((item, index) => <li key={index} className="flex items-start gap-2.5" data-id="element-206">
                    <div className="bg-red-100 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-207">
                      <X className="w-4 h-4 text-red-500" strokeWidth={3} data-id="element-208" />
                    </div>
                    <span className="text-sm text-charcoal" data-id="element-209">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}